import styled from "styled-components";

interface SpinnerOverlayProps {
  backgroundSecondary: string;
}

export const PaymentContainer = styled.div`
  display: flex;
  max-width: 526px;
  margin: 0 auto;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

export const PaymentFormContainer = styled.form``;

export const ParentContainer = styled.div<any>`
  display: ${({ overlayState }) => (overlayState ? "none" : "block")};
  padding: 32px 16px 48px;

  @media screen and (max-width: 768px) {
    padding: 32px 16px 24px;
  }
`;

export const SpinnerOverlay = styled.div<SpinnerOverlayProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 240px;
  width: 100%;
  position: relative;

  ::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 32px);
    height: calc(100% - 64px);
    background: ${({ backgroundSecondary }) => backgroundSecondary};
    border-radius: 8px;
  }
`;

export const SubmittingText = styled.div`
  position: relative;
  margin-top: 16px;
  padding: 0 16px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 500;
  text-align: center;
  max-width: 320px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const SubmittingSubtext = styled.div`
  position: relative;
  margin-top: 4px;
  padding: 0 16px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  max-width: 320px;

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ErrorMessageCustomBox = styled.div`
  margin-bottom: 32px;

  @media screen and (max-width: 768px) {
    margin-left: -16px;
    margin-right: -16px;
  }
`;

export const PaymentInfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0 0;
  margin-top: 32px;

  @media screen and (max-width: 768px) {
    margin-top: 24px;
    padding: 12px 0;
  }
`;

export const PaymentInfoText = styled.div<any>`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-right: 4px;
  color: ${({ textBody }) => textBody};

  @media screen and (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
